import React, { type FC, useRef, useState } from 'react';

interface Card3DBoxProps {
  multiple?: number;
  perspective?: string;
  className?: string;
  children: React.ReactNode;
}

const Card3DBox: FC<Card3DBoxProps> = ({
  multiple = 10,
  perspective = '500px',
  className,
  children,
}) => {
  const boxRef = useRef<HTMLDivElement>(null);

  function transformElement(x: number, y: number) {
    const rect = boxRef.current?.getBoundingClientRect();
    if (rect) {
      const calcX = -(y - rect.y - rect.height / 2) / multiple;
      const calcY = (x - rect.x - rect.width / 2) / multiple;
      // const percentage = (((x - rect.x) / rect.width) * 1000) / 10;
      setBoxTransform(`rotateX(${calcX}deg) rotateY(${calcY}deg)`);
    }
  }

  const [boxTransform, setBoxTransform] = useState('rotateX(0) rotateY(0)');

  function onTransform(e: React.MouseEvent) {
    window.requestAnimationFrame(() => {
      transformElement(e.clientX, e.clientY);
    });
  }

  function onReset() {
    window.requestAnimationFrame(() => {
      setBoxTransform('rotateX(0) rotateY(0)');
    });
  }

  return (
    <div
      ref={boxRef}
      className={className}
      style={{
        transformStyle: 'preserve-3d',
        perspective,
        transform: boxTransform,
      }}
      onMouseMove={onTransform}
      onMouseLeave={onReset}
    >
      {children}
    </div>
  );
};
export default Card3DBox;
